<mat-dialog-content>

  @if(!data.entryFee) {
    @for(eachShow of data.entryDetails.shows; track eachShow.id) {
      <equine-ui-nx-show-entry-order-items
        [orderItems]="eachShow.orderItems"
        [total]="eachShow.total"
        [showData]="eachShow.show"
      ></equine-ui-nx-show-entry-order-items>
    }
  }

  <div>
    Please select your payment method:

    <mat-form-field class="full-width">
      <mat-select (selectionChange)="onSelectionChanged($event)">
        <mat-option [value]="'paypal'">Paypal</mat-option>
        <mat-option [value]="'creditCard'">Credit Card</mat-option>
      </mat-select>
    </mat-form-field>

    @if(paymentTypeSelected() === 'paypal') {
    <equine-ui-nx-show-entry-pay-with-paypal
      [showPaymentDetailsIds]="entryDetailsIds"
      (success)="onSuccess()"
      [fromEntryFee]="data.entryFee"
    ></equine-ui-nx-show-entry-pay-with-paypal>
    }

    @if(paymentTypeSelected() === 'creditCard') {
    <equine-ui-nx-show-entry-pay-with-cc
      [showPaymentDetailsIds]="entryDetailsIds"
      (success)="onSuccess()"
      (payingStatus)="onPaying($event)"
      [fromEntryFee]="data.entryFee"
    ></equine-ui-nx-show-entry-pay-with-cc>
    }

  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="action-section">
    <button mat-raised-button (click)="closeDialog()" [disabled]="paying()">Cancel</button>
  </div>
</mat-dialog-actions>